import { render } from "./WizardStepper.vue?vue&type=template&id=6c191011&scoped=true"
import script from "./WizardStepper.vue?vue&type=script&lang=js"
export * from "./WizardStepper.vue?vue&type=script&lang=js"

import "./WizardStepper.vue?vue&type=style&index=0&id=6c191011&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c191011"]])

export default __exports__